import {useEffect, useState} from "react";
import {InputText} from "primereact/inputtext";

interface EditableFieldProps {
    label: string;
    value: string;
    onChange: (val: string) => void;
}

const EditableField = ({ label, value: initialValue, onChange }: EditableFieldProps) => {

    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(initialValue);

    // Update internal value if initialValue prop changes
    useEffect(() => {
        if (!isEditing) {
            setValue(initialValue ?? "");
        }
    }, [initialValue, isEditing]);

    const handleBlur = () => {
        setIsEditing(false);
        onChange?.(value);
    };

    return (
        <div className="flex flex-column md:flex-row align-items-start mb-3">
            <div className="md:w-3 w-full">
                <div className="text-left p-1 border-round-sm bg-primary font-bold">
                    {label}
                </div>
            </div>
            <div className="md:w-9 w-full">
                <div className="text-left p-1 border-round-sm bg-primary cursor-pointer">
                    {isEditing ? (
                        <InputText
                            autoFocus
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            onBlur={handleBlur}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleBlur();
                                }
                            }}
                            className="w-full"
                        />
                    ) : (
                        <span
                            onClick={() => setIsEditing(true)}
                            className="editable-field cursor-pointer hover:surface-hover transition-colors border-round block flex align-items-center gap-2">
                                <span>{value}</span>
                                <i className="pi pi-pencil text-sm text-gray-600" />
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};
export default EditableField;